import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Navbar from "./components/Navbar";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Membership from "./Pages/Membership";
import Education from "./Pages/Education";
import Affiliation from "./Pages/Affiliation";
import Advocacy from "./Pages/Advocacy";
import Events from "./Pages/Events";
import Resources from "./Pages/Resources";
import Careers from "./Pages/Careers";
import AdminLogin from "./Pages/adminLogin";
import AdminDashboard from "./Pages/AdminDashboard";
import AddMember from "./Pages/AddMember";
import MemberLogin from "./Pages/MemberLogin";
import MemberPortal from "./Pages/MemberPortal";

const PageLayout = ({ children, type = "standard" }) => {
  const styles = {
    contentWithNav: {
      minHeight: "100vh",
      width: "100%",
      backgroundColor: "#f9f9f9",
      display: "flex",
      flexDirection: "column",
    },
    standardContainer: {
      flex: 1,
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "2rem",
      width: "100%",
    },
    dashboardContainer: {
      flex: 1,
      width: "100%",
      backgroundColor: "#f3f4f6",
      display: "flex",
      flexDirection: "column",
    },
  };

  if (type === "dashboard") {
    return <div style={styles.dashboardContainer}>{children}</div>;
  }

  return (
    <div style={styles.contentWithNav}>
      <div style={styles.standardContainer}>{children}</div>
    </div>
  );
};

const routes = [
  { path: "/", element: <Home />, type: "standard" },
  { path: "/about", element: <About />, type: "standard" },
  { path: "/membership", element: <Membership />, type: "standard" },
  { path: "/education", element: <Education />, type: "standard" },
  { path: "/affiliation", element: <Affiliation />, type: "standard" },
  { path: "/advocacy", element: <Advocacy />, type: "standard" },
  { path: "/events", element: <Events />, type: "standard" },
  { path: "/resources", element: <Resources />, type: "standard" },
  { path: "/careers", element: <Careers />, type: "standard" },
  { path: "/adminLogin", element: <AdminLogin />, type: "standard" },
  { path: "/memberLogin", element: <MemberLogin />, type: "standard" },
  { path: "/memberlogin", element: <MemberLogin />, type: "standard" },
  { path: "/AddMember", element: <AddMember />, type: "standard" },
];

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div style={{
          minHeight: "100vh",
          backgroundColor: "#f9f9f9",
          display: "flex",
          flexDirection: "column",
        }}>
          <Navbar />
          <Routes>
            {routes.map(({ path, element, type }) => (
              <Route
                key={path}
                path={path}
                element={<PageLayout type={type}>{element}</PageLayout>}
              />
            ))}
            <Route
              path="/AdminDashboard"
              element={
                <PageLayout type="dashboard">
                  <ProtectedRoute requireStaff>
                    <AdminDashboard />
                  </ProtectedRoute>
                </PageLayout>
              }
            />
            <Route
              path="/memberPortal"
              element={
                <PageLayout type="dashboard">
                  <ProtectedRoute requireMember>
                    <MemberPortal />
                  </ProtectedRoute>
                </PageLayout>
              }
            />
            <Route
              path="/memberportal"
              element={
                <PageLayout type="dashboard">
                  <ProtectedRoute requireMember>
                    <MemberPortal />
                  </ProtectedRoute>
                </PageLayout>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
